export default {
  path: '/system',
  component: () => import('@/layout/index'),
  redirect: '/system/config',
  name: 'System',
  meta: {
    title: '系统管理',
    icon: 'el-icon-setting'
  },
  children: [
    {
      path: 'config',
      name: 'SystemConfig',
      component: () => import('@/views/system/config'),
      meta: { title: '系统配置' }
    },
    {
      path: 'app-user',
      name: 'AppUser',
      component: () => import('@/views/app_user/index'),
      meta: { title: '移动端用户' }
    },
    {
      path: 'agreement',
      name: 'SystemAgreement',
      component: () => import('@/views/system/agreement'),
      meta: { title: '协议管理' }
    },
    {
      path: 'redeem',
      name: 'SystemRedeem',
      component: () => import('@/views/system/redeem'),
      meta: { title: '兑换码管理' }
    }
  ]
} 